import React from 'react';
import moment from 'moment';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Menu from '@material-ui/core/Menu';
import Typography from '@material-ui/core/Typography';
import StageDescriptionTooltip from './StageDescriptionTooltip';
import StageDateEdit from './StageDateEdit';

const useStyles = makeStyles((theme: any) => ({
  stockOnHandMenu: {
    cursor: 'default',
    '& .MuiList-root': {
      width: 85,
      [theme.breakpoints.down('sm')]: {
        width: 145,
      },
    },
    '& .MuiList-padding': { padding: theme.spacing(1) },
  },
  text: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: theme.spacing(1),
    },
  },
  stockOnHandText: { color: theme.palette.primary.main, fontWeight: 600 },
  finalText: {
    marginLeft: theme.spacing(0.5),
    [theme.breakpoints.up('sm')]: {
      marginTop: -theme.spacing(0.75),
      marginLeft: 0,
    },
  },
  stockOnHandDate: { color: theme.palette.brand.greenDark },
}));

export default function StockOnHandMenu({
  line,
  stockOnHand,
  anchorEl,
  open,
  setOpen,
  handleStageUpdate,
  addOrDeleteError,
  setAutoSave = (arg) => {},
  stockOnHandPosition,
}) {
  const classes = useStyles();
  const sohAnchorPosition = stockOnHandPosition > 85;

  function handleClose() {
    setOpen(false);
    setAutoSave(true);
  }

  function handleUpdateToStockOnHand(stageId: string, key: string, date: Date) {
    handleStageUpdate(stageId, key, date);
    setOpen(false);
  }

  return (
    <Menu
      open={open}
      onClose={handleClose}
      onMouseLeave={handleClose}
      keepMounted
      anchorEl={anchorEl}
      className={classes.stockOnHandMenu}
      anchorOrigin={{
        vertical: 'top',
        horizontal: sohAnchorPosition ? 'left' : 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: sohAnchorPosition ? 'right' : 'left',
      }}
      disableRestoreFocus
    >
      <div>
        <StageDescriptionTooltip stage={stockOnHand}>
          <div className={classes.text}>
            <Typography variant="subtitle1" className={classes.stockOnHandText}>
              Stock
            </Typography>
            <Typography
              variant="subtitle1"
              className={classes.stockOnHandText + ' ' + classes.finalText}
            >
              on hand
            </Typography>
          </div>
        </StageDescriptionTooltip>
        {line.edit && (
          <StageDateEdit
            stage={stockOnHand}
            stockOnHand={true}
            handleStageUpdate={handleUpdateToStockOnHand}
            addOrDeleteError={addOrDeleteError}
            setAutoSave={setAutoSave}
          />
        )}
        {!line.edit && (
          <Typography variant="body2" className={classes.stockOnHandDate}>
            {moment(stockOnHand?.start).format('MMM DD')}
          </Typography>
        )}
      </div>
    </Menu>
  );
}
